import * as React from "react";
const SvgArrowRight = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M11.269 4.269a1.034 1.034 0 0 1 1.462 0l7 7a1.034 1.034 0 0 1 0 1.463l-7 7a1.034 1.034 0 1 1-1.462-1.463l5.233-5.234H5a1.035 1.035 0 0 1 0-2.07h11.502L11.269 5.73a1.034 1.034 0 0 1 0-1.462"
}));
export default SvgArrowRight;
//# sourceMappingURL=ArrowRight.js.map